import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { RootState } from './types'
import { auth } from './modules/auth'
import { errors } from './modules/errors'
import { loading } from './modules/loading'
import { drawer } from './modules/drawer'
import { shippingAddress } from './modules/shippingAddress'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    loading,
    errors,
    auth,
    drawer,
    shippingAddress,
  },
  plugins: [
    createPersistedState({
      key: 'ffmembers',
      paths: ['auth.user', 'shippingAddress.shippingAddresses'],
      storage: localStorage,
    }),
  ],
}

export default new Vuex.Store<RootState>(store)
